import Label from './base';
export default Label;
//# sourceMappingURL=index.js.map